import { render } from "./ApplicantCard.vue?vue&type=template&id=5369af59&scoped=true"
import script from "./ApplicantCard.vue?vue&type=script&lang=js"
export * from "./ApplicantCard.vue?vue&type=script&lang=js"

import "./ApplicantCard.vue?vue&type=style&index=0&id=5369af59&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5369af59"]])

export default __exports__